<template>
	<div class="detailHeader">
		<p class="detailHeader__location"><i class="glyphicon glyphicon-map-marker"></i> {{ifEmpty(profile.location)}}</p>

		<my-favoriteaction v-bind:id="profile.id" v-bind:label="true" v-bind:action="true"></my-favoriteaction>
		<!-- <div class="favoritemark">
			<span class="favoritemark__text">お気に入り</span> <i v-on:click="favoriteAction(profile.id)" v-bind:class="{'icon2_favorite': fav, 'icon2_add_to_favorite': !fav}" class="favoritemark__icon" title="お気に入り"></i>
		</div> -->

		<h2 v-text="profile.name" class="detailHeader__heading"></h2>

		<p v-if="profile.phone1" class="detailHeader__phoneNumber"><i class="glyphicon glyphicon glyphicon-earphone"></i> <a v-bind:href="'tel:' + profile.phone1">{{profile.phone1}}</a></p>

		<p v-if="profile.mail1" class="detailHeader__email"><i class="glyphicon glyphicon glyphicon-envelope"></i> <a v-bind:href="'mailto:' + profile.mail1 + '?subject=' + urlparam.mail">{{profile.mail1}}</a></p>

		<!--
		<div class="studioIcons">
			<template v-for="item in icons">
				<span v-bind:class="item.icon" class="tooltip1 studioIcons__icon" title="{{item.title}}"><span>{{item.title}}</span></span>
			</template>
		</div>
		-->
	</div>

	<p v-if="profile.promoword" class="studioCatchcopy"><strong v-html="profile.promoword | nltobr"></strong></p>

	<div class="mainVisual">
		<template v-if="wWidth > 767">
			<div class="mainImage">
				<img v-if="crImage" v-bind:src="crImage" alt="{{profile.name + 'の写真1'}}">
				<img v-else src="/static/images/thumb/no_image_r.jpg" alt="no image">
			</div>
			<ul class="thumbList2">
				<li v-for="image in images" v-on:click="changeImg($index, $event)" class="js-gallery-thumb"><img v-bind:src="image" alt="{{profile.name + 'の写真' + ($index + 2)}}"></li>
			</ul>
		</template>
		<template v-else>
			<div id="carousel-{{profile.id}}" class="carousel slide visible-xs-block" data-ride="carousel">
				<template v-if="images">
					<!-- Indicators -->
					<div class="carouselIndicatorsWrapper">
						<ol class="carousel-indicators">
							<li v-for="image in images" data-target="#carousel-{{profile.id}}" v-bind:data-slide-to="$index" v-bind:class="{'active': $index === 0}"></li>
						</ol>
					</div>
				</template>
				<!-- Wrapper for slides -->
				<div class="carousel-inner" role="listbox">
					<template v-if="images">
						<div v-for="image in images" v-bind:class="{'active': $index === 0}" class="item">
							<img v-bind:src="image" alt="{{profile.name + 'の写真' + ($index + 1)}}">
						</div>
					</template>
					<template v-else>
						<div class="item active">
							<img v-else src="/static/images/thumb/no_image_r.jpg" alt="no image">
						</div>
					</template>
				</div>
				<template v-if="images">
					<!-- Controls -->
					<a class="left carousel-control" href="#carousel-{{profile.id}}" role="button" data-slide="prev">
						<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
						<span class="sr-only">Previous</span>
					</a>
					<a class="right carousel-control" href="#carousel-{{profile.id}}" role="button" data-slide="next">
						<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
						<span class="sr-only">Next</span>
					</a>
				</template>
			</div>
		</template>
	</div>

	<div v-if="profile.vr" class="block">
		<div class="vrFrame">
			<iframe v-bind:src="'https://my.matterport.com/show/?m=' + profile.vr + '&lang=jp'" frameborder="0" allowfullscreen allow="vr"></iframe>
		</div>
	</div>

	<div class="block">
		<p v-if="profile.prword" v-html="profile.prword | nltobr"></p>

		<div class="studio_map">
			<p v-if="profile.postcode">郵便番号：{{profile.postcode}}</p>
			<p v-if="profile.address">住所：{{profile.address}} {{profile.building_name}}</p>
			<p v-if="profile.phone1">電話：<a v-bind:href="'tel:' + profile.phone1">{{profile.phone1}}</a> {{profile.phone1_exp}}</p>
			<template v-if="profile.phone2">
				<p>電話：<a v-bind:href="'tel:' + profile.phone2">{{profile.phone2}}</a> {{profile.phone2_exp}}</p>
			</template>
			<template v-if="profile.phone3">
				<p>電話：<a v-bind:href="'tel:' + profile.phone3">{{profile.phone3}}</a> {{profile.phone3_exp}}</p>
			</template>
			<p v-if="profile.fax">FAX：{{profile.fax}}</p>
			<p>※お問い合わせの際は、studio DATA BASE を見たとお伝えになるとスムーズです。</p>
			<p v-if="profile.mail1">Eメール：<a v-bind:href="'mailto:' + profile.mail1 + '?subject=' + urlparam.mail">{{profile.mail1}}</a> {{profile.mail1_exp}}</p>
			<template v-if="profile.mail2">
				<p>Eメール：<a v-bind:href="'mailto:' + profile.mail2 + '?subject=' + urlparam.mail">{{profile.mail2}}</a> {{profile.mail2_exp}}</p>
			</template>
			<p v-if="profile.url_1">URL：<a v-bind:href="profile.url_1" target="_blank">{{profile.url_1}}</a> {{profile.url_1_exp}}</p>
			<template v-if="profile.url_2">
				<p>URL：<a v-bind:href="profile.url_2" target="_blank">{{profile.url_2}}</a> {{profile.url_2_exp}}</p>
			</template>
		</div>

		<div v-if="blog.count" class="block" id="bloginfo">
			<h3 class="headLine2">スタジオからのお知らせ</h3>
			<div class="bloginfoFrame">
				<iframe v-bind:src="'/s/blogs/blog_index/' + profile.id"></iframe>
			</div>
		</div>

		<div class="dataTable">
			<table class="table table-bordered">
				<tr v-if="profile.pay1 === '1' || profile.pay2 === '1'" class="dataTable__emphasis">
					<th>スチール料金</th>
					<td><template v-if="studio.steel_charge !== '0'">{{studio.s_unit_time}}時間：<b>{{studio.steel_charge}}円</b> <span class="dataTable__supplyment">{{studio.steel_charge_remarks}}</span></template></td>
				</tr>
				<tr v-if="profile.pay1 === '1' || profile.pay2 === '1'" class="dataTable__emphasis">
					<th>ムービー料金</th>
					<td><template v-if="studio.movie_charge !== '0'">{{studio.m_unit_time}}時間：<b>{{studio.movie_charge}}円</b> <span class="dataTable__supplyment">{{studio.movie_charge_remarks}}</span></template></td>
				</tr>
			</table>
			<table class="table table-bordered">
				<tr v-if="profile.pay2 === '1' && (studio.area_m2 != '0' || studio.area_tsubo)">
					<th>面積</th>
					<td>{{ifEmpty(studio.area_m2)}}㎡ {{ifEmpty(studio.area_tsubo)}}坪</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && studio.max_height != '0'">
					<th>最大高</th>
					<td>{{ifEmpty(studio.max_height)}}m</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && (studio.site_m2 || studio.site_tsubo)">
					<th>敷地面積</th>
					<td>{{ifEmpty(studio.site_m2)}}㎡ {{ifEmpty(this.studio.site_tsubo)}}坪</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && studio.power">
					<th>電気容量</th>
					<td>{{studio.power}}</td>
				</tr>
				<tr v-if="(profile.pay1 === '1' || profile.pay2 === '1') && (studio.s_time || studio.m_time)">
					<th>最低時間</th>
					<td>
						スチール：{{ifEmpty(studio.s_time)}}時間
						ムービー：{{ifEmpty(studio.m_time)}}時間
					</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && (studio.type_rhorizont !== '0' || studio.type_interior_house !== '0')">
					<th>スタジオの種類</th>
					<td>
						<template v-if="studio.type_rhorizont !== '0'">アールホリゾント</template>
						<template v-if="studio.type_interior_house !== '0'">ハウススタジオ</template>
					</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && equipment.situation.length">
					<th>シチュエーション</th>
					<td>
						<ul class="horizontalList2">
							<li v-for="situation in equipment.situation" v-text="situation"></li>
						</ul>
					</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && equipment.facility.length">
					<th>撮影設備</th>
					<td>
						<ul class="horizontalList2">
							<li v-for="facility in equipment.facility" v-text="facility"></li>
						</ul>
					</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && equipment.service.length">
					<th>諸サービス</th>
					<td>
						<ul class="horizontalList2">
							<li v-for="service in equipment.service" v-text="service"></li>
						</ul>
					</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && studio.other_situation">
					<th>その他</th>
					<td>{{{studio.other_situation | nltobr}}}</td>
				</tr>
				<!-- <tr v-if="profile.pay2 === '1' && studio.other_equipment">
					<th>その他設備・備品</th>
					<td>{{studio.other_equipment}}</td>
				</tr>
				<tr v-if="profile.pay2 === '1' && studio.other_service">
					<th>その他サービス</th>
					<td>{{studio.other_service}}</td>
				</tr> -->
			</table>
		</div>

		<p class="notes"><em>※スタジオ使用料金は変動している可能性があります。必ず各スタジオにお問い合せください。</em></p>

		<div v-if="studio.sketch_map_url" class="sketchLink">
			<a v-bind:href="studio.sketch_map_url" target="_blank"><i class="glyphicon glyphicon-arrow-right"></i> 見取り図を見る</a>
		</div>

		<div v-if="profile.information" class="studioNews">
			{{{profile.information}}}
		</div>

		<template v-if="studio.parking === '1'">
			<p>駐車場あり<template v-if="studio.parking_count">: 収容台数 {{studio.parking_count}}</template></p>
		</template>
		<template v-else>
			<p>駐車場なし</p>
		</template>

		<div v-if="map.url" class="block">
			<h3 class="headLine2">交通アクセス</h3>
			<p v-if="profile.access_1">アクセス1: {{{profile.access_1 | nltobr}}}</p>
			<p v-if="profile.access_2">アクセス2: {{{profile.access_2 | nltobr}}}</p>
			<div class="gmap">
				<iframe v-bind:src="map.url" width="1200" height="1200" frameborder="0" style="border:0" allowfullscreen></iframe>
			</div>
		</div>

		<div class="block">
			<my-sns v-if="profile"></my-sns>
		</div>

	</div>

	<div v-if="sibling" class="block">
		<h3 class="headLine">関連スタジオを見る</h3>
		<template v-if="wWidth > 767">
			<ul class="hidden-xs thumbList clearfix">
				<li v-for="item in sibling">
					<a v-link="item.id">
						<div class="thumbList__thumb">
							<div v-my-preloadimg="{src: item.img_1, class: ['img-responsive', 'loadingEfect']}">
								<my-loading></my-loading>
							</div>
							<!-- <img v-bind:src="item.img_1" class="img-responsive" alt="{{item.name}}"> -->
							<p v-text="item.location" class="thumbList__area2"></p>
							<p v-text="item.name" class="thumbList__name"></p>
						</div>
					</a>
				</li>
			</ul>
		</template>
		<template v-else>
			<div id="carousel-sibling" class="carousel slide visible-xs-block" data-ride="carousel">
				<!-- Indicators -->
				<div class="carouselIndicatorsWrapper">
					<ol class="carousel-indicators">
						<li v-for="(key, item) in sibling" data-target="#carousel-sibling" v-bind:data-slide-to="key" v-bind:class="{'active': key === 0}"></li>
					</ol>
				</div>
				<!-- Wrapper for slides -->
				<div class="carousel-inner hasCaption" role="listbox">
					<div v-for="(key, item) in sibling" v-bind:class="{'active': key === 0}" class="item">
						<a v-link="item.id">
							<img v-bind:src="item.img_1" alt="{{item.name}}">
							<div class="carousel_caption">
								<p v-text="item.location" class="thumbList__area2"></p>
								<p v-text="item.name" class="thumbList__name"></p>
							</div>
						</a>
					</div>
				</div>
				<!-- Controls -->
				<a class="left carousel-control" href="#carousel-sibling" role="button" data-slide="prev">
					<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
					<span class="sr-only">Previous</span>
				</a>
				<a class="right carousel-control" href="#carousel-sibling" role="button" data-slide="next">
					<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
					<span class="sr-only">Next</span>
				</a>
			</div>
		</template>
	</div>

	<div v-if="nearest" class="block">
		<h3 class="headLine">近隣スタジオ・レコメンド</h3>
		<template v-if="wWidth > 767">
			<ul class="hidden-xs thumbList clearfix">
				<li v-for="item in nearest">
					<a v-link="item.id" target="_blank">
						<div class="thumbList__thumb">
							<img v-bind:src="item.img_1" class="img-responsive" alt="{{item.name}}">
							<p v-text="item.location" class="thumbList__area2"></p>
							<p v-text="item.name" class="thumbList__name"></p>
						</div>
					</a>
				</li>
			</ul>
		</template>
		<template v-else>
			<div id="carousel-nearest" class="carousel slide visible-xs-block" data-ride="carousel">
				<!-- Indicators -->
				<div class="carouselIndicatorsWrapper">
					<ol class="carousel-indicators">
						<li v-for="(key, item) in nearest" data-target="#carousel-nearest" v-bind:data-slide-to="key" v-bind:class="{'active': key === 0}"></li>
					</ol>
				</div>
				<!-- Wrapper for slides -->
				<div class="carousel-inner hasCaption" role="listbox">
					<div v-for="(key, item) in nearest" v-bind:class="{'active': key === 0}" class="item">
						<a v-link="item.id" target="_blank">
							<img v-bind:src="item.img_1" alt="{{item.name}}">
							<div class="carousel_caption">
								<p v-text="item.location" class="thumbList__area2"></p>
								<p v-text="item.name" class="thumbList__name"></p>
							</div>
						</a>
					</div>
				</div>
				<!-- Controls -->
				<a class="left carousel-control" href="#carousel-nearest" role="button" data-slide="prev">
					<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
					<span class="sr-only">Previous</span>
				</a>
				<a class="right carousel-control" href="#carousel-nearest" role="button" data-slide="next">
					<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
					<span class="sr-only">Next</span>
				</a>
			</div>
		</template>
	</div>
</template>

<script>
import { getPrefecturesList } from '../vuex/getters';
module.exports = {
	route: {
		data: function(transition){
			// console.log('detail route data');
			this.handleResize();
			this.$nextTick(function () {
				// var path = window.location.hash.replace('#!', '');
				// var hasHash = path.lastIndexOf('#');
				// if (hasHash !== -1){
				// 	// console.log($('#bloginfo'));
				// 	this.smoothScroll(path.substr(hasHash));
				// } else {
				// 	// ページ遷移後、頭に移動
				// 	this.smoothScroll('body');
				// }

				// ページ遷移後、頭に移動
				this.smoothScroll('body');
			});
		},
		canReuse: false
	},
	vuex: {
		getters: {
			prefecturesList: getPrefecturesList
		}
	},
	data: function () {
		var hostname = document.location.hostname;

		return {
			pageMeta: this.$route.pageMeta,
			fav: false,
			profile: '',
			studio: '',
			blog: '',
			map: {
				mode: 'place',
				url: '',
				param: {
					key: 'AIzaSyAqrkrcs_0c6Tesx8UrXPghgHH1svq3dbw',
					q: '',
					center: '',
					zoom: '18',
					maptype: ''
				}
			},
			sibling: '',
			nearest: '',
			equipment: {
				situation: '',
				facility: '',
				service: ''
			},
			icons: '',
			images: '',
			crImage: '',
			wWidth: '',
			urlparam: {
				url: hostname,
				mail: 'studio DATA BASEからお問い合せ'
			},
			reload: {
				times: 3,
				delay: 5000
			}
		};
	},
	created: function(){
		// console.log('detail created');
		var url = this.createJsonPath('profile');

		// get request
		this.getJson(url);
		// this.getJson2(url, 3, 5000);

		// overwrite url
		this.pageMeta.url = encodeURIComponent(window.location);

		// seta meta
		var setMetaUnwatch = this.$watch('profile', function(){
			// console.log(this.profile);
			var detail_title_short = this.pageMeta.title_short.replace(' by POWER PAGE', '');
			var description = this.profile.prword.replace(/\r\n/g, '').replace(/\s+/g, '');
			var descriptionMaxLength = 300;
			if (description.length > descriptionMaxLength) {
				description = description.substring(0, (descriptionMaxLength - 3)) + '...';
			}

			var metaObj = {
				title: this.profile.location + ' ' + this.profile.name + ' ' + this.profile.promoword.replace(/\r\n/g, '') + ' | ' + detail_title_short,
				keywords: this.profile.keyword,
				description: description,
				url: this.pageMeta.url,
				image: encodeURIComponent(window.location.protocol + '//' + window.location.host + this.crImage)
			};

			this.setMeta(metaObj);
			setMetaUnwatch();
		});
	},
	beforeCompile: function(){
		// console.log('detail beforeCompile');
	},
	ready: function () {
		// console.log('detail ready');
		// related studio
		var relatedArr = ['sibling', 'nearest'];
		for (var i = 0; i < relatedArr.length; i++){
			var url = this.createJsonPath(relatedArr[i]);
			this.getRelatedJson(url, relatedArr[i]);
		}

		// console.log(this.equipment);

		// var path = window.location.hash.replace('#!', '');
		// var hasHash = path.lastIndexOf('#');
		// if (hasHash !== -1){
		// 	// console.log($('#bloginfo'));
		// 	this.smoothScroll(path.substr(hasHash));
		// }

		// googleAnalytics
		// var setGAwatch = this.$watch('profile.name', function(){
		// 	if (this.profile.name){
		// 		var trackingUrl = window.location.hash.replace(/^#!/, '');
		// 		window.ga('create', 'UA-4877520-11', 'auto');
		// 		window.ga('set', {
		// 			page: trackingUrl,
		// 			title: this.profile.name + ' | ' + this.pageMeta.title_short
		// 		});
		// 		window.ga('send', 'pageview');
		// 		setGAwatch();
		// 	}
		// });

		// iframe auto height
		// $(window).on('load', function(){
		// 	var _d = $('.bloginfoFrame iframe').get(0).contentWindow.document;
		// 	console.log(
		// 		_d.body.scrollHeight, _d.documentElement.scrollHeight,
		// 		_d.body.offsetHeight, _d.documentElement.offsetHeight,
		// 		_d.body.clientHeight, _d.documentElement.clientHeight
		// 	);
		// });

		// resize - いずれapp.vueからbroadcastで動くようにする
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
	},
	beforeDestroy: function () {
		// console.log('detail beforeDestroy');
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('load', this.handleResize);

		// 閲覧履歴
		this.addHistory(this.profile.id);

		// ディスパッチ
		this.$dispatch('leaveDetail');
	},
	methods: {
		debug: function(){
			console.log(this.sibling);
			console.log(this.nearest);
		},
		devMode: function(){
			return this.$route.devmode;
		},
		createJsonPath: function(keyword){
			var devmode = this.devMode();
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var apipath = host + '//' + hostname + '/s/api/';
			var url = '';
			if (keyword === 'profile'){
				url = devmode ? '/static/json/sample_detail.json' : apipath + 'profile/' + this.$route.params.id;
			} else if (keyword === 'sibling'){
				url = apipath + 'parents/' + this.$route.params.id;
			} else if (keyword === 'nearest'){
				url = apipath + 'nearest/' + this.$route.params.id;
			}
			// console.log(url);
			return url;
		},
		// getJson2: function(url, retry, delay){
		// 	this.$http.get(url).then(function (response) {
		// 		console.log(response.status);
		// 	}, function (response) {
		// 		// error callback
		// 		console.log(response.status);
		// 		if (retry > 0){
		// 			console.log('retry');
		// 			setTimeout(this.getJson2, delay, url, retry - 1, delay);
		// 		}
		// 	});
		// },
		getJson: function(url, times = this.reload.times, delay = this.reload.delay){
			var devmode = this.devMode();
			this.$http.get(url).then(function (response) {
				// success callback
				var json = response.data;
				// console.log(json.Profiles);
				this.$data.pageTitle = json.Profiles.name;
				this.$data.profile = json.Profiles;
				this.$data.studio = json.Studios;
				this.$data.blog = json.Blogs;

				this.$dispatch('topicpath', json.Profiles);

				// googlemap
				var reg = /^\[GMAP\]/;
				if (reg.test(json.Profiles.latlng)) {
					this.$data.map.url = json.Profiles.latlng.replace(reg, '');
				} else {
					this.$data.map.param.center = json.Profiles.latlng ? json.Profiles.latlng.replace(/['"]+/g, '') : '';
					// this.$data.map.param.center = '35.673720, 139.708000';
					// if (this.$data.map.param.center){
					// 	this.$data.map.param.q = this.$data.map.param.center;
					// } else {
					this.$data.map.param.q = json.Profiles.address ? encodeURIComponent(json.Profiles.address) : '';
					this.$data.map.param.q += json.Profiles.building_name ? encodeURIComponent(' ' + json.Profiles.building_name) : '';
					// this.$data.map.param.q += json.Profiles.name ? encodeURIComponent(' ' + json.Profiles.name) : '';
					// }
					// console.log(this.map.param);
					if (this.map.param.center || this.map.param.q){
						var mapparam = '';
						var length = 0;
						for (var k in this.map.param){
							var joint = (length === 0) ? '?' : '&';
							mapparam += this.map.param[k] ? joint + k + '=' + this.map.param[k] : '';
							length++;
						}
						this.$data.map.url = 'https://www.google.com/maps/embed/v1/' + this.map.mode + mapparam;
					}
				}

				// 諸設備, アイコン情報を追加
				var eq = this.equipmentList();
				// var eqArray = [];
				var situation = [];
				var facility = [];
				var service = [];

				var icons = this.addIconsConf();
				var iconsArray = [];

				for (var stprop in json.Studios){
					// for (var eqprop in eq){
					// 	if (stprop === eqprop && json.Studios[stprop] === '1'){
					// 		eqArray.push(eq[stprop]);
					// 	}
					// }

					// situation
					for (var situationprop in eq.situation){
						if (stprop === situationprop && json.Studios[stprop] === '1'){
							situation.push(eq.situation[stprop]);
						}
					}
					// facility
					for (var facilityprop in eq.facility){
						if (stprop === facilityprop && json.Studios[stprop] === '1'){
							facility.push(eq.facility[stprop]);
						}
					}
					// service
					for (var serviceprop in eq.service){
						if (stprop === serviceprop && json.Studios[stprop] === '1'){
							service.push(eq.service[stprop]);
						}
					}

					// icon
					for (var iconprop in icons){
						if (stprop === iconprop && json.Studios[stprop] === '1'){
							var obj = {
								icon: icons[stprop].icon,
								title: icons[stprop].title
							};
							iconsArray.push(obj);
						}
					}
				}
				// console.log(situation);
				// console.log(facility);
				// console.log(service);
				// console.log(iconsArray);
				// this.$data.equipment = eqArray;
				this.$data.equipment.situation = situation;
				this.$data.equipment.facility = facility;
				this.$data.equipment.service = service;
				this.$data.icons = iconsArray;

				// images
				var imagesArray = [];
				var imgDir = devmode ? '/static/images/sample_studio/' : '/s/img/studio/';
				for (var i = 1; i <= 10; i++){
					if (json.Profiles['img_' + i]){
						var imgFileName = json.Profiles['img_' + i].replace(/^(.+)(\.[a-z]+)$/, '$1_r$2');
						imagesArray.push(imgDir + imgFileName);
					}
				}
				// console.log(imagesArray);
				if (imagesArray.length !== 0){
					this.$data.images = imagesArray;
					this.$data.crImage = imagesArray[0];
				}

				// this.$set('result', dataArray);
			}, function (response) {
				// error callback
				console.log(response.status);
				this.pageTitle = 'ページが見つかりませんでした。';
				if (times > 0){
					// console.log('retry');
					setTimeout(this.getJson, delay, url, times - 1, delay);
				}
			});
		},
		getRelatedJson: function(url, keyword, times = this.reload.times, delay = this.reload.delay){
			this.$http.get(url).then(function (response) {
				var json = response.data;
				var dataArray = [];
				if (json.length !== 0){
					var displayed = json.length < 8 ? json.length : 8;
					if (keyword === 'sibling'){
						displayed = json.length;
					}
					for (var i = 0; i < displayed; i++){
						if (typeof (json[i]) !== 'undefined'){
							// console.log(json[i]);
							json[i].Profiles.permalink = 'detail/' + json[i].Profiles.id;

							for (var i2 = 1; i2 <= 10; i2++){
								if (json[i].Profiles['img_' + i2]){
									json[i].Profiles['img_' + i2] = '/s/img/studio/' + json[i].Profiles['img_' + i2].replace(/^(.+)(\.[a-z]+)$/, '$1_r$2');
								} else {
									json[i].Profiles['img_' + i2] = '/static/images/thumb/no_image_r.jpg';
								}
							}
							dataArray.push(json[i].Profiles);
						}
					}
				} else {
					dataArray = null;
				}
				// console.log(dataArray);
				this.$set(keyword, dataArray);
			}, function (response) {
				// error callback
				console.log(response.status);
				this.pageTitle = 'データの取得に失敗しました';
				if (times > 0){
					// console.log('related retry');
					setTimeout(this.getRelatedJson, delay, url, keyword, times - 1, delay);
				}
			});
		},
		equipmentList: function(){
			var obj = {
				// 被写体・シチュエーション
				situation: {
					ck_natural_light: '自然光',
					ck_eu_style_belong: '洋風（建物）',
					ck_jp_style_belong: '和風（建物）',
					ck_jp_style_room: '和室',
					ck_bathroom: 'バスルーム',
					ck_terrace: 'テラス・デッキ',
					ck_living: 'リビング',
					ck_office_style: 'オフィス',
					ck_restaurant_and_banquet_hall: 'レストラン・カフェ',
					ck_rooftop: '屋上',
					ck_multi_space: '多目的スペース',
					ck_floor: '木床・タイル床',
					ck_jp_garden: '庭（和風）',
					ck_eu_garden: '庭（洋風）',
					ck_furniture: '家具常備'
					// ck_hospital: '病院',
				},
				// 撮影設備
				facility: {
					ck_kitchen: 'キッチン',
					ck_down_shot: '俯瞰撮影',
					ck_synchronous_recording: '同時録音',
					ck_water: '水使用可（ホリゾント内）',
					ck_communication_environment: 'Wi-Fi',
					ck_makeup_room: 'メイクルーム',
					ck_direct_carrying: '車直接搬入',
					ck_shower_room: 'シャワールーム',
					ck_stock_room: 'ストックルーム・倉庫',
					ck_large_elevator: '大型エレベーター'
					// ck_vtr: 'ムービー',
					// ck_rhorizont_white: 'アールホリゾント（白ホリ）',
				},
				// 諸サービス
				service: {
					ck_flash_rental: 'ストロボレンタル',
					ck_hmi_rental: 'HMIレンタル',
					ck_machine_rental: '機材レンタル',
					ck_assistant_service: 'アシスタントサービス'
				}
			};
			return obj;
		},
		ifEmpty: function(value){
			if (value){
				return value;
			} else {
				return '--';
			}
		},
		handleResize: function(){
			this.wWidth = window.innerWidth;
		},
		changeImg: function(i, e){
			// console.log(e);
			this.crImage = this.images[i];
		},
		addHistory: function(id){
			var item = window.localStorage.getItem('history');
			var histories = item ? JSON.parse(item) : [];
			// 配列から同じIDを削除
			if (histories.indexOf(id) >= 0){
				for (var i = 0; i < histories.length; i++){
					if (histories[i] === id){
						histories.splice(i, 1);
					}
				}
			}
			// 配列の末尾にIDを追加
			histories.push(id);
			// 5件まで
			if (histories.length > 5){
				histories.splice(0, histories.length - 5);
			}

			// ローカルストレージに保存
			window.localStorage.setItem('history', JSON.stringify(histories));
		}
	},
	components: {
		'my-sns': require('./sns_buttons.vue'),
		'my-favoriteaction': require('./favorite_action.vue')
	},
	mixins: [
		require('../mixins/setMeta.js'),
		require('../mixins/addIconsConf.js'),
		require('../mixins/getPrefectures.js'),
		require('../mixins/smoothScroll.js')
	]
};
</script>

<style scoped lang="scss">
// .mainImage__view{
// 	transition: all .5s ease;
// 	opacity: 1;
//
// 	&--fadein{
// 		opacity: 0;
// 	}
// }
</style>



// WEBPACK FOOTER //
// detail.vue?63608460